import { useRef } from 'react';
import { motion, useMotionValueEvent } from 'framer-motion';

export default function Telemetry({ progress, opacity }) {
  const altRef = useRef();
  const barRef = useRef();

  useMotionValueEvent(progress, 'change', (v) => {
    if (altRef.current) {
      altRef.current.textContent = `${Math.max(0, Math.round(402 * (1 - v)))} KM`;
    }
    if (barRef.current) {
      barRef.current.style.transform = `scaleY(${v})`;
    }
  });

  return (
    <motion.div
      style={{ opacity }}
      className="fixed left-6 top-1/2 -translate-y-1/2 z-30 hidden lg:flex flex-col items-center gap-4 pointer-events-none"
      data-testid="altitude-telemetry"
    >
      <span className="font-mono text-[9px] uppercase tracking-[0.3em] text-slate-600 [writing-mode:vertical-rl]">
        Altitude
      </span>
      <div className="relative w-px h-36 bg-white/10 overflow-hidden">
        <div
          ref={barRef}
          className="absolute inset-x-0 top-0 h-full origin-top accent-gradient"
          style={{ transform: 'scaleY(0)' }}
        />
      </div>
      <span
        ref={altRef}
        className="font-mono text-[10px] tracking-[0.2em] text-magenta tabular-nums"
      >
        402 KM
      </span>
    </motion.div>
  );
}
